import { Tag } from 'antd';
import React, { ReactElement } from 'react';
import { IDictionary } from '~utilities/IDictionary';
import InterestMethodEnum from '../../Api/Loan/InterestMethodEnum';
import ILoan from '~Api/Loan/ILoan';

const interestMethodClasses: IDictionary<string> = {
    [InterestMethodEnum.Custom]: 'custom',
    [InterestMethodEnum.InterestMethod360]: 'day360',
    [InterestMethodEnum.InterestMethod365]: 'day365',
};

const interestMethodLabels: IDictionary<string> = {
    [InterestMethodEnum.Custom]: 'Custom',
    [InterestMethodEnum.InterestMethod360]: '360 Day',
    [InterestMethodEnum.InterestMethod365]: '365 Day',
};

export default function InterestMethodTag(props: {
    loan: ILoan;
}): ReactElement {
    const { loan } = props;

    return (
        <Tag className={`interest-method-tag ${interestMethodClasses[loan.interestMethod]}`}>
            {interestMethodLabels[loan.interestMethod]}
        </Tag>
    );
}